import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of, switchMap } from 'rxjs';
import { setInitialStoreState } from '../../../../common/utils';
import { ShipmentTransportOrderItemFacade } from './shipment-transport-order-item.facade';
import { Injectable } from '@angular/core';
import { TransportOrderIdView } from '../../../models';
import { Permission, PERMISSION_CONFIG } from '../../../../common';
import { AuthFacade } from '../../auth';

@Injectable({ providedIn: 'root' })
export class ShipmentTransportOrderItemGuard {
  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    const {
      queryParams: { transportOrderNumber = null },
    } = route;
    const identifier: TransportOrderIdView = { transportOrderNumber };

    this.shipmentTransportOrderItemFacade.setShipmentTransportOrderIdentifier(identifier);

    return this.authFacade
      .hasPermission$(
        PERMISSION_CONFIG[Permission.TrackAndTrace][Permission.CanaryTransportLevel][Permission.ShipmentCustoms][
          Permission.Read
        ],
      )
      .pipe(
        switchMap(() => {
          return of(true);
        }),
      );
  }

  constructor(
    private shipmentTransportOrderItemFacade: ShipmentTransportOrderItemFacade,
    private authFacade: AuthFacade,
  ) {}

  canDeactivate(): boolean {
    return setInitialStoreState(this.shipmentTransportOrderItemFacade);
  }
}
